import { Buffergs925ekssbch as Buffer } from './Buffer.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
  add2suhfggl4zvkk as add,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkBoundsw7d8y6z7j2xc as checkBounds } from './-Util.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealSourceClass;
function RealSource() {
  if (RealSourceClass === VOID) {
    class $ {
      constructor(source) {
        this.c4k_1 = source;
        this.d4k_1 = false;
        this.e4k_1 = new (Buffer())();
      }
      i3y() {
        return this.e4k_1;
      }
      y4i(sink, byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.d4k_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().o2(toString(message_0));
        }
        if (this.e4k_1.q2() === 0n) {
          var read = this.c4k_1.y4i(this.e4k_1, 8192n);
          if (read === -1n)
            return -1n;
        }
        // Inline function 'kotlin.comparisons.minOf' call
        var b = this.e4k_1.q2();
        var toRead = byteCount <= b ? byteCount : b;
        return this.e4k_1.y4i(sink, toRead);
      }
      j3y() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.d4k_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        return this.e4k_1.j3y() && this.c4k_1.y4i(this.e4k_1, 8192n) === -1n;
      }
      k3y(byteCount) {
        if (!this.p3y(byteCount))
          throw EOFException().d4i("Source doesn't contain required number of bytes (" + byteCount.toString() + ').');
      }
      p3y(byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.d4k_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().o2(toString(message_0));
        }
        while (this.e4k_1.q2() < byteCount) {
          if (this.c4k_1.y4i(this.e4k_1, 8192n) === -1n)
            return false;
        }
        return true;
      }
      s3y() {
        this.k3y(1n);
        return this.e4k_1.s3y();
      }
      w4i(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        if (this.e4k_1.q2() === 0n) {
          var read = this.c4k_1.y4i(this.e4k_1, 8192n);
          if (read === -1n)
            return -1;
        }
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.e4k_1.q2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(tmp0);
        var tmp$ret$1 = a <= b ? a : b;
        var toRead = convertToInt(tmp$ret$1);
        return this.e4k_1.w4i(sink, startIndex, startIndex + toRead | 0);
      }
      a4j(sink, byteCount) {
        try {
          this.k3y(byteCount);
        } catch ($p) {
          if ($p instanceof EOFException()) {
            var e = $p;
            sink.z4i(this.e4k_1, this.e4k_1.q2());
            throw e;
          } else {
            throw $p;
          }
        }
        this.e4k_1.a4j(sink, byteCount);
      }
      b4j(sink) {
        var totalBytesWritten = 0n;
        while (!(this.c4k_1.y4i(this.e4k_1, 8192n) === -1n)) {
          var emitByteCount = this.e4k_1.u4i();
          if (emitByteCount > 0n) {
            totalBytesWritten = add(totalBytesWritten, emitByteCount);
            sink.z4i(this.e4k_1, emitByteCount);
          }
        }
        if (this.e4k_1.q2() > 0n) {
          totalBytesWritten = add(totalBytesWritten, this.e4k_1.q2());
          sink.z4i(this.e4k_1, this.e4k_1.q2());
        }
        return totalBytesWritten;
      }
      n4i() {
        this.k3y(2n);
        return this.e4k_1.n4i();
      }
      k40() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.d4k_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        return buffered(new (PeekSource())(this));
      }
      m6() {
        if (this.d4k_1)
          return Unit_instance;
        this.d4k_1 = true;
        this.c4k_1.m6();
        this.e4k_1.y4();
      }
      toString() {
        return 'buffered(' + toString(this.c4k_1) + ')';
      }
    }
    initMetadataForClass($, 'RealSource', VOID, VOID, [Source()]);
    RealSourceClass = $;
  }
  return RealSourceClass;
}
//region block: exports
export {
  RealSource as RealSource1sojixeyllf40,
};
//endregion

//# sourceMappingURL=RealSource.mjs.map
